import AdminRegistration from './AdminRegistration';

export default AdminRegistration;
